import type { UIAdapterModule } from "../types";
import { parseBedrockStdout } from "@ligament/adapter-bedrock/ui";
import { buildBedrockConfig } from "@ligament/adapter-bedrock/ui";
import { BedrockConfigFields } from "./config-fields";

export const bedrockUIAdapter: UIAdapterModule = {
  type: "bedrock",
  label: "Amazon Bedrock (HIPAA)",
  parseStdoutLine: parseBedrockStdout,
  ConfigFields: BedrockConfigFields,
  buildAdapterConfig: buildBedrockConfig,
};
